import { getLocalAccessToken } from "../../utils/helper";
import api, {
  handleErrorCreateAndUpdate,
  handleErrorShowCache,
} from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.releaseSpeakerVersion;

/*  
   RELEASE SPEAKER VERSION
*/

export const createReleaseSpeakerVersion = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getReleaseSpeakerVersion = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getReleaseSpeakerVersionDetail = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateReleaseSpeakerVersion = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

//? remove iot partner
export const removeReleaseSpeakerVersion = (id) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => Toast("success", "Thành công"))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

// update mode release
export const updateReleaseSpeakerVersionMode = (id, data, callback) => {
  api
    .patch(`${URL}/release-mode/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

// CACHE
export const getCacheReleaseSpeakerVersion = (callback) => {
  api
    .get(`${URL}/cache`)
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorShowCache(err);
    });
};

export const clearCacheSpeakerVersion = (callback) => {
  api
    .post(`${URL}/clear-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const deployCacheSpeakerVersion = (callback) => {
  api
    .post(`${URL}/deploy-cache`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
